"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Button = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Button = _styledComponents["default"].div.withConfig({
  displayName: "styles__Button"
})(["", ";"], function (a) {
  return a.color && "\n    button {\n      color: white;\n      background-color: ".concat(a.color.main || a.color, ";\n      border-color: transparent;\n      &:hover,\n      &:focus{\n        color: white;\n        background-color: ").concat(a.color.active || a.color.main || a.color, ";\n        border-color: transparent;\n      }\n    }      \n  ");
});

exports.Button = Button;